import React from 'react';

import { useCampaign } from '../../contexts';
import { useAutoscroll, useLpPageView, useSections } from '../../hooks';
import { CampaignWidthProvider, CampaignConfigProvider } from '../providers';
import { CampaignWrapper } from '../campaign-wrapper';
import { CampaignSections } from '../campaign-sections';
import { CampaignFonts } from '../campaign-fonts';
import { CampaignCss } from '../campaign-css';

import './viewer.scss';

export function Viewer() {
  const campaign = useCampaign();
  const sections = useSections(campaign);

  useAutoscroll(sections);
  useLpPageView();

  return (
    <CampaignConfigProvider>
      <CampaignWidthProvider padding={16} campaign={campaign}>
        <div>
          <CampaignFonts />
          <CampaignCss campaign={campaign} sections={sections} />
          <CampaignWrapper padding={16} campaign={campaign}>
            <CampaignSections sections={sections} />
          </CampaignWrapper>
        </div>
      </CampaignWidthProvider>
    </CampaignConfigProvider>
  );
}
